import { getStripePublicKey } from "~/components/stripe";
import { useEnv } from "~/queries/environment/useEnv";
import { IEnvWeb, IListing } from "~/types/api-types";

type StripePublicKey = IEnvWeb["stripe"]["stripe_public_key"];

/**
 * Resolves the Stripe public key for a listing's country from the env service's
 * web config. Reads through `useEnv`, so it shares the query cache with every
 * other consumer of that payload instead of fetching it again. Stays `null`
 * until the config loads, and if it fails to load.
 */
const useStripePublicKey = (
  country: IListing["country"],
): StripePublicKey | null => {
  const { data } = useEnv();

  return data?.stripe
    ? getStripePublicKey(country.toLowerCase(), data.stripe)
    : null;
};

export { useStripePublicKey };
